import React, { useContext } from 'react';
import { PriceRowContextContainer } from '../price-row-context';
import { insertTableAds } from '../ads';
import { PriceRow } from '../price-row/row-types';
import { PriceListFilterContext } from 'src/areas/product/price-list-filter-context';
import { createOfferFromPriceItem } from '../utils';
import { IPriceListBodyProps } from './types';

const PriceListBody: React.FC<IPriceListBodyProps> = props => {
  const {
    sortedPrices,
    showMorePrices,
    numberOfVisiblePrices,
    adOffset,
    productName,
    productId,
    media,
    brand,
    priceDisplay,
    campaign,
  } = props;
  const { filters } = useContext(PriceListFilterContext);

  return (
    <div>
      {sortedPrices &&
        sortedPrices.length > 0 &&
        insertTableAds(
          sortedPrices
            .slice(0, showMorePrices ? undefined : numberOfVisiblePrices)
            .map((item, index) => {
              const rowKey = `${item.id}-${index}`;
              const offer = createOfferFromPriceItem(item, filters);
              return (
                <PriceRowContextContainer
                  key={rowKey}
                  productId={productId}
                  productName={productName}
                  productImage={media?.first}
                  brand={brand}
                  priceDisplay={priceDisplay}
                  campaign={campaign}
                  showExpandButton
                  offer={offer}
                >
                  <PriceRow item={item} index={index} />
                </PriceRowContextContainer>
              );
            }),
          adOffset ?? 0
        )}
    </div>
  );
};

export default PriceListBody;
